module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('a', {
    attrs: {
      "id": "title3"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("One")])]), _vm._v(" "), _c('h1', {
    staticClass: "subtitle"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("THE NAVY FINDS SAN DIEGO")])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The U.S. Navy first came to San Diego’s shore during the opening weeks of the Mexican War. Its mission was strategic—to seize the city and establish American rule. The draw was San Diego’s incomparable bay and central location along the lengthy California coast. The aim was to provide a strategic center for supply and logistics that would support naval operations along the entire west coast of Mexico and California.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("The sloop-of-war "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Cyane")]), _vm._v(" with its 18 guns, under the command of Comdr. Samuel Francis Du Pont, first arrived off Point Loma at dawn on July 29, 1846. Although it carried an army detachment of irregulars led by western trailblazer Maj. John C. Frémont and scout Kit Carson, the first ashore that summer day were two boatloads of sailors and marines who proceeded directly to the central plaza of the village (today’s Old Town) to raise the American colors. Their welcome was warm, with many of San Diego’s leading families in favor of the inevitability of U.S. rule and the attractive promise of economic gain and community stability.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("As crucial as the navy was to the first American chapter of San Diego’s rich history, it was not until 50 years later, at the beginning of the 20th century, that the navy was to return with any permanence. Again the attraction was both strategic and geographic in nature as the navy built both a coaling station and an experimental wireless facility at the southwestern corner of the country to support extended fleet operations. Again the city’s reception was warm, and again, the promise was for economic gain and stable growth. This time, the navy engaged in the acquisition of property and negotiations for support that would set the foundation for everything that was to come.")])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "89%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439635865_i0004.jpg",
      "src": "images/e9781439635865_i0004.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("San Diego naval history began when two boatloads of sailors and marines from sloop-of-war "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Cyane")]), _vm._v(" captured San Diego and raised the American flag over the town square (today’s Old Town) on July 29, 1846. They were followed later in the day by irregular troops of the California Battalion led by the noted frontier explorer Maj. John C. Frémont. Warmly welcomed by most San Diegans, American forces quickly built Fort Stockton on the heights above Old Town and garrisoned the village. "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Cyane")]), _vm._v(" sailors would later participate in land battles near Los Angeles that secured Alta California for the United States, and the sloop helped capture and blockade ports in Baja California and along the Mexican coast. (Naval Historical Center, from watercolor by "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Cyane")]), _vm._v(" gunner William Myers.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "73%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439635865_i0005.jpg",
      "src": "images/e9781439635865_i0005.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Comdr. Samuel Francis Du Pont, of the celebrated Du Pont family of American industrialists, commanded "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Cyane")]), _vm._v(" and ordered the first American flag to be raised over San Diego. By the time he arrived in San Diego, Du Pont had already served in the navy for 31 years and had commanded schooner "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Grampus")]), _vm._v(", sloop-of-war "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Warren")]), _vm._v(", and frigate "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Congress")]), _vm._v(". Well-thought-of in the navy, Du Pont would later help establish the U.S. Naval Academy and would rise to the rank of rear admiral while commanding Union fleet actions against Port Royal and Charleston, South Carolina, during the Civil War. This lithograph was printed "), _c('em', {
    staticClass: "i"
  }, [_vm._v("c")]), _vm._v(". 1848 with Du Pont in the uniform of a navy commander. (Naval Historical Center.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "89%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439635865_i0006.jpg",
      "src": "images/e9781439635865_i0006.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Frigate "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Congress,")]), _vm._v(" commissioned May 1842, was the last fully sail-powered frigate built by the U.S. Navy. As the Pacific Squadron flagship, she carried the flag of Commodore Robert Stockton during the Mexican War and frequently visited San Diego while the village served as the logistics base for American naval operations along the Mexican west coast. Her deep draught was ill-suited for San Diego Bay, where twice she ran aground. The first navyman to die and be buried in San Diego was Ordinary Seaman John Simpson, who fell from the fore royal yardarm of "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Congress")]), _vm._v(" while at anchor in the bay and was later buried at Fort Rosecrans Cemetery. "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Congress")]), _vm._v(" met her demise famously in 1862 in Hampton Roads, Virginia, in battle with Confederate ironclad "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Virginia")]), _vm._v(" the day before the remarkable engagement between "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Virginia")]), _vm._v(" and "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Monitor")]), _vm._v(". (Naval Historical Center.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "89%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439635865_i0007.jpg",
      "src": "images/e9781439635865_i0007.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Following the Mexican War, the navy rarely visited San Diego until ships such as the steam sloop "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Hartford")]), _vm._v(", Adm. David Glasgow Farragut’s famous Civil War flagship, began to visit in the years before the beginning of the 20th century. "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Hartford")]), _vm._v(" served as an apprentice sea-training ship along the West Coast from 1884 to 1899 and, during one visit, assigned her cutter permanently to the San Diego Naval Militia. Tradition says the "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Hartford")]), _vm._v(" cutter never lost a pulling-boat race (a favorite form of sport where boats from different ships would engage in spirited rowing competitions for fleet bragging rights). (Naval Historical Center.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "73%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439635865_i0008.jpg",
      "src": "images/e9781439635865_i0008.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The army transferred land at LaPlaya to the navy in 1901 for a coaling station that the navy began constructing in 1904. This site at the mouth of the bay became the navy’s first permanent base in San Diego. Due to the shallowness of the bay, only small vessels (like destroyers "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Henshaw")]), _vm._v(" and "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Farquhar")]), _vm._v(" seen above in 1925) could pull up to the pier. Others had to be replenished from coal barges while at anchor off Coronado. No sooner had Lt. Comdr. J. H. L. Holcombe assumed duties as the navy’s first officer-in-charge in San Diego than the chamber of commerce began to lobby the navy to expand the base with a dry dock and repair yard. Coal can clearly be seen below in this "), _c('em', {
    staticClass: "i"
  }, [_vm._v("c")]), _vm._v(". 1930 photograph, laid out in long piles just east of Rosecrans Street. (Naval Historical Center.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "73%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439635865_i0009.jpg",
      "src": "images/e9781439635865_i0009.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "89%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439635865_i0010.jpg",
      "src": "images/e9781439635865_i0010.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("On May 12, 1906, San Diego’s first wireless radio station, dubbed NPL for its three-letter call sign (Navy-Point Loma), rose on the crest of Point Loma, the site selected to provide maximum radio range over the ocean to the south and west of the United States. During its early years, NPL set several records for long-distance ship-to-shore radio transmission. Immediately following the San Francisco earthquake, the commander of the Pacific Squadron used NPL to relay orders to several ships to urgently proceed northward to provide aid, the first-ever use of wireless to direct fleet operations at sea. NPL would serve for over 40 years at its site on Catalina Boulevard, and in this 1924 photograph, the nearby naval coaling station can also be seen. (National Archives.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "89%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439635865_i0011.jpg",
      "src": "images/e9781439635865_i0011.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("The Chollas Heights radio transmitter site, east of downtown San Diego, was the navy’s first land purchase in San Diego, bought in July 1914 for $15,000 in a land deal brokered by a helpful San Diego Chamber of Commerce. Upon its commission in 1917, the site was described as the most powerful radio station in the world and was the station that first relayed word of the Japanese attack on Pearl Harbor to Washington. The navy integrated the site (shown here in June 1958) into its worldwide radio network but demolished the towers in the mid-1990s to make room for family housing. (U.S. Navy/Naval Facilities Engineering Command.)")])])])])])]), _c('a', {
    attrs: {
      "id": "title3"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63ee93d4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781439635865_c01.vue
// module id = 78
// module chunks = 0